import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SimpleModalComponent, SimpleModalService } from '@looorent/ngx-simple-modal';
import { ToastrService } from 'ngx-toastr';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { OrganizationsService } from 'src/app/Services/organizations.service';

@Component({
    selector: 'app-addcitationmanualpaymentmodal',
    templateUrl: './addcitationmanualpaymentmodal.component.html',
    styleUrls: ['./addcitationmanualpaymentmodal.component.scss'],
    standalone: false
})
export class AddcitationmanualpaymentmodalComponent extends SimpleModalComponent<any, null> implements OnInit {

  public Citation: any = null;

    constructor(private modalService: SimpleModalService, private route: ActivatedRoute, private apiService: ApiServiceBase, private organizationsService: OrganizationsService, private toastService: ToastrService) {
      super();
    }

    ngOnInit(): void {

    }

}
